export default {
  cancel: 'İptal',
  circle_config: 'Daire yapılandırması',
  confirm: 'Onayla',
  confirm_delete:
    'Bu özelliği silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.',
  create: 'Oluştur',
  delete_geometry: 'Geometrisini sil',
  delete_vertex: 'Köşeyi kaldır',
  document_upload_failed: 'Belge yüklemesi başarısız oldu.',
  draw_circle: 'Merkezden Daire',
  draw_circle_2pt: 'Manuel Daire',
  draw_dialog_begin_drawing:
    'Çizmeye Başla - Harita üzerinde herhangi bir yere tıkla',
  draw_dialog_cancel_drawing: 'Çizimi İptal Et - ESC Tuşu',
  draw_dialog_remove_vertex: 'Son Köşeyi Kaldır - Sağ Tık',
  draw_dialog_save: 'Kaydet - Çift Tık',
  draw_dialog_save_single: 'Kaydet - Tek Tık',
  draw_dialog_title: 'Çizim Talimatları',
  draw_line: 'Çizgi',
  draw_point: 'Nokta',
  draw_polygon: 'Çokgen',
  draw_position: 'Mevcut Konum',
  draw_rectangle: 'Dikdörtgen',
  edit_dialog_cancel_drawing:
    'Çizimi İptal Et - Çizimi iptal etmek için iptal butonuna tıklayın.',
  edit_dialog_modify_shape:
    'Şekli Düzenle - Şekli değiştirmek için bir köşeyi sürükleyin veya çokgen üzerinde yeni bir köşe ekleyin.',
  edit_dialog_remove_vertex: 'Köşeyi Kaldır - Bir köşeye tıklayarak kaldırın.',
  edit_dialog_save:
    'Kaydet - Değişikliklerinizi kaydetmek için kaydet butonuna tıklayın.',
  edit_dialog_title: 'Düzenleme Talimatları',
  filter_searchbox_placeholder: 'Ara',
  icon_scaling_cluster: 'Küme İkon Ölçeği',
  icon_scaling_cluster_log: 'Küme Logaritmik Ölçeği',
  icon_scaling_field: 'Alan İkon Ölçeklendirmeyi Aç/Kapat',
  icon_scaling_label: 'İkon Ölçeği',
  icon_scaling_zoom_in: 'Büyütme Ölçeği',
  icon_scaling_zoom_out: 'Küçültme Ölçeği',
  identical_values_filter:
    'Bu alan yalnızca bir farklı değere sahiptir ve filtrelenemez.',
  image_upload_failed: 'Görüntü yüklemesi başarısız oldu.',
  information: 'Bilgi',
  invalid_geometry: 'Geometri geçersiz',
  invalid_lat_lon: 'Sağlanan koordinatlar seçilen yerel alan içinde değildir.',
  invalid_lat_long_range:
    'Geçersiz koordinatlar: Enlem ve boylam değerleri geçerli aralıklar içinde olmalıdır.',
  layer_add_new_location: 'Yeni konum ekle',
  layer_dataview_header: 'Veri Görünümleri',
  layer_filter_clear_all: 'Tüm filtreleri temizle',
  layer_filter_dropdown_select: 'Birden fazla seç',
  layer_filter_greater_than: 'Büyüktür',
  layer_filter_header: 'Filtre',
  layer_filter_less_than: 'Küçüktür',
  layer_filter_reset_all: 'Tüm filtreleri sıfırla',
  layer_filter_select: 'Listeden filtreyi seç',
  layer_filter_set_filter: 'Filtreyi ayarla',
  layer_grid_legend_ratio: 'Renkleri boyuta göre oran olarak göster',
  layer_group_hide_layers: 'Grup içindeki tüm katmanları gizle',
  layer_style_cluster: 'Birden Fazla Konum',
  layer_style_display_hover: 'Üzerine gelmeyi etkinleştir',
  layer_style_display_labels: 'Etiketleri görüntüle',
  layer_style_header: 'Stil',
  layer_style_opacity: 'Katman opaklığını değiştir:',
  layer_style_select_theme: 'Tematik stili seç',
  layer_style_switch_all: 'tümünü değiştir',
  layer_style_switch_caption:
    'Görünürlüğü değiştirmek için etiketlere tıklayın veya',
  layer_visibility: 'Görünürlüğü Aç/Kapat',
  layer_zoom_to_extent: 'Filtrelenmiş katman kapsamına yakınlaştır',
  layers: 'Katmanlar',
  link: 'Bağlantı',
  loading: 'Yükleniyor',
  location_clear_all: 'Konumları temizle',
  location_close_without_save:
    'Değişiklikleri kaydetmeden konumu kapatmak ister misiniz?',
  location_delete: 'Konumu sil',
  location_listview_full: 'Konumlar için liste görünümü dolu.',
  location_remove: 'Seçimden özelliği kaldır',
  location_save: 'Değişiklikleri buluta kaydet',
  location_save_changes:
    'Bu konumdaki değişiklikleri kaydetmek istiyor musunuz?',
  location_zoom: 'Özellik sınırlarına haritayı yakınlaştır',
  locations: 'Konumlar',
  modify_geometry: 'Geometrisini değiştir',
  no_data_filter: 'Bu alan veri içermiyor ve filtrelenemez.',
  no_layers: 'Yerel alanda erişilebilir katman yok.',
  no_locales:
    'Hesabınız onaylandı ancak hiçbir yerel alana erişiminiz yok. Bu, muhtemelen bir yöneticinin size gerekli rolleri vermemiş olmasından kaynaklanmaktadır. Bunu çözmek için bir yönetici ile iletişime geçin.',
  no_options_available: 'Mevcut seçenek yok.',
  no_results: 'Bu arama için sonuç yok',
  ok: 'Tamam',
  pill_component_remove: 'Kaldır',
  pin: 'Sabitle',
  radius: 'Yarıçap',
  remove_document_confirm:
    'Bu belgeyi kaldırmak istediğinizden emin misiniz? Bu işlem geri alınamaz.',
  remove_image_confirm:
    'Görüntüyü kaldırmak istediğinizden emin misiniz? Bu işlem geri alınamaz.',
  remove_item_confirm: 'Öğeyi kaldır?',
  remove_last_vertex: 'Son köşeyi kaldır',
  report: 'Rapor',
  save: 'Kaydet',
  toolbar_admin: 'Hesap yönetim görünümünü aç',
  toolbar_current_location: 'Mevcut konum',
  toolbar_fullscreen: 'Tam ekran harita görünümü',
  toolbar_login: 'Giriş yap',
  toolbar_logout: 'Çıkış yap',
  toolbar_zoom_in: 'Yakınlaştır',
  toolbar_zoom_out: 'Uzaklaştır',
  toolbar_zoom_to_area: 'Bölgeye yakınlaştır',
  units: 'Birimler',
  zoom_to: 'Yakınlaştır',
};
